import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogDismissOption } from '@shared/confirmation-dialog/modal-dialog-dismiss-option';

@Component({
    selector: 'scitis-command-content-modal',
    templateUrl: './command-content-modal.component.html',
    styleUrls: ['./command-content-modal.component.scss'],
    standalone: false
})
export class CommandContentModalComponent {
  @Input() status: string = '';
  @Input() payload: string = '';

  constructor(private readonly activeModal: NgbActiveModal){}
  
  onClose(): void {
      this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }
}
